export const DEFAULT_MEMBERS_FILTER = ["status=active"];

export function update_members_filter(filter) {
    return {
        type: "update_members_filter",
        payload: filter
    }
}

export function reset_members_filter() {
    return {
        type: "update_members_filter",
        payload: DEFAULT_MEMBERS_FILTER
    }
}